import { render, staticRenderFns } from "./SelectRoot.vue?vue&type=template&id=206275fc&scoped=true&"
import script from "./SelectRoot.vue?vue&type=script&lang=js&"
export * from "./SelectRoot.vue?vue&type=script&lang=js&"
import style0 from "./SelectRoot.vue?vue&type=style&index=0&id=206275fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206275fc",
  null
  
)

export default component.exports